import './_product-options-drawer.scss';
import component from './product-options-drawer';

export default component;
